import { render, staticRenderFns } from "./webapp-disabled.vue?vue&type=template&id=d8bd85d8&"
import script from "./webapp-disabled.vue?vue&type=script&lang=js&"
export * from "./webapp-disabled.vue?vue&type=script&lang=js&"
import style0 from "./webapp-disabled.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports